import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { extract } from '@app/core';
import { LoginComponent } from './login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { RegisterComponent } from './register/register.component';
import { RecaptchaV3CustomModule } from '@app/shared/recaptcha-v3/recaptcha-v3.module';
import { VerifyEmailComponent } from './verify-email/verify-email.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent, data: { title: 'Login' } },
  { path: 'register', component: RegisterComponent, data: { title: 'Register' } },
  { path: 'verify-email', component: VerifyEmailComponent, data: { title: 'Verify Email' } },
  { path: 'login/forgot-password', component: ForgotPasswordComponent, data: { title: 'Passwort vergessen' } },
  { path: 'login/reset-password/:hash', component: ResetPasswordComponent, data: { title: 'Neues Passwort festlegen' } }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule, RecaptchaV3CustomModule],
  providers: []
})
export class LoginRoutingModule {}
